import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './theme.css';

// Force SW update on new deploy
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg) reg.update();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Dismiss the inline splash once the app has mounted, keeping a graceful
// minimum on-screen time so the reveal animation reads as intentional.
const dismissSplash = () => {
  const splash = document.getElementById('bp-splash');
  if (!splash) return;
  const MIN_VISIBLE_MS = 1600;
  const elapsed = performance.now();
  const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
  window.setTimeout(() => {
    splash.classList.add('bp-splash--hide');
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
    // Fallback removal if transitionend never fires.
    window.setTimeout(() => splash.remove(), 900);
  }, wait);
};

if (document.readyState === 'complete') {
  requestAnimationFrame(dismissSplash);
} else {
  window.addEventListener('load', () => requestAnimationFrame(dismissSplash), { once: true });
}
